module.exports = [
	{
		"question": "What do I need to bring to the course?",
		"answer": "A laptop with Sublime text installed, a charger, University ID and water."
	},
	{
		"question": "What is Sublime Text?",
		"answer": "It’s a free text editor that we'll use to write our code in."
	},
	{
		"question": "When will I hear from you?",
		"answer": "We will always contact you directly via email. We will email you about your application and details about the course soon. If you haven't received the email please double check your SPAM folder."
	},
	{
		"question": "Where is the course being held?",
		"answer": "The 2-day course will be held on your university campus. We will release the specific room information to successful applicants only."
	},
	{
		"question": "How much does the course cost?",
		"answer": "You can see the prices of each course by Applying for a course at your university. Applying is free."
	},
	{
		"question": "I have some experience coding, can I apply?",
		"answer": "The short answer is yes, the long answer is: remember that this is a beginner course so if you feel that you are accomplished in the material covered, you may find the pace too slow."
	},
	{
		"question": "Why does the price vary by university?",
		"answer": "The price may vary due to the fact that some courses are subsidised by the University."
	},
	{
		"question": "How do I cancel my place on the course?",
		"answer": "You can find details of how to request a refund on your acceptance email. A refund must be requested at least 3 days before the course start date. If it is later than this, you may not be able to receive a refund as we may not be able to fill your place."
	},
	{
		"question": "I have never coded before, am I welcome on this course?",
		"answer": "Absolutely yes! This course is designed for students who have never written a line of code in their lives."
	},
	{
		"question": "What exactly will I learn?",
		"answer": "You will learn how to make a website from scratch. You will learn how to use HTML, CSS and Javascript to build it, just like the pros. You'll be taught by a teacher who is very experienced. By the end of the course, you will know how to make a website and have the confidence and knowledge to learn more languages."
	},
	{
		"question": "I can’t attend the course, can I see the course content?",
		"answer": "Sorry, it’s not possible for us to provide this."
	},
	{
		"question": "What happens if I attend one day and not the other?",
		"answer": "If you are not attended due to failings on our part, we will investigate. If not, then it will not be possible to issue a refund."
	},
	{
		"question": "I am only able to attend the second day can I still do the course?",
		"answer": "No, the course builds up so it would not be a good idea to attend only the second day."
	},
	{
		"question": "I’m an alumni of one of the Universities with courses, can I apply?",
		"answer": "If you have access to the University and a University email address, you can apply."
	},
	{
		"question": "Will you be launching courses at other Universities/my University?",
		"answer": "Yes we will, please register here and we’ll let you know when we launch."
	},
	{
		"question": "Is there after course support?",
		"answer": "Yes, you will receive personalised learning guidelines from your teachers and we have a Slack channel where you can ask questions."
	},
	{
		"question": "Do I need a Mac?",
		"answer": "No, if you have a Windows or Linux that’s fine too. We’ll ask you in your application and try to place you in a class with others who have the same type of computer."
	},
	{
		"question": "I don’t have a computer, can I attend?",
		"answer": "If you can borrow a friend’s computer we suggest doing that otherwise at the moment we don’t have laptops to lend to students."
	},
	{
		"question": "What time does the course run?",
		"answer": "It starts at 10am (though please arrive 10 minutes beforehand) and ends at 5pm on Saturday and Sunday. There will be a one hour lunchtime at 1pm."
	},
	{
		"question": "Will there be future courses?",
		"answer": "We hope so but unless it is on our website, it hasn’t been confirmed."
	},
	{
		"question": "I applied but I have not heard anything, will I be offered a place?",
		"answer": "We received more applications than places so not everyone can receive a place. Our places are offered on a rolling basis and you may be offered a place up to the last day so even if you have not received an offer a week before the course, people may pull out at the last minute and we may offer you their place."
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/FAQ/faqs.json
 ** module id = 580
 ** module chunks = 0
 **/